import { useState } from 'react';
import BadgeCelebrationModal from './BadgeCelebrationModal';

const BadgeIcon = ({ slug, size = 20 }) => {
  const props = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.5, strokeLinecap: 'round', strokeLinejoin: 'round' };
  switch (slug) {
    case 'seed': return <svg {...props}><path d="M12 22V12"/><path d="M12 12C12 12 8 10 8 6a4 4 0 0 1 8 0c0 4-4 6-4 6z"/><path d="M12 15c0 0-3 1-4 4"/></svg>;
    case 'feather': return <svg {...props}><path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"/><line x1="16" y1="8" x2="2" y2="22"/><line x1="17.5" y1="15" x2="9" y2="15"/></svg>;
    case 'share': return <svg {...props}><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>;
    case 'diploma': return <svg {...props}><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c3 3 9 3 12 0v-5"/></svg>;
    case 'calendar-check': return <svg {...props}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/><polyline points="9 16 11 18 15 14"/></svg>;
    case 'flame': return <svg {...props}><path d="M12 2c0 0-4 4-4 8.5a4 4 0 0 0 8 0C16 6 12 2 12 2z"/><path d="M12 12c0 0-2 1.5-2 3.5a2 2 0 0 0 4 0C14 13.5 12 12 12 12z"/></svg>;
    case 'trophy': return <svg {...props}><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 9a6 6 0 0 0 12 0"/><line x1="12" y1="15" x2="12" y2="19"/><line x1="8" y1="19" x2="16" y2="19"/></svg>;
    case 'book': return <svg {...props}><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>;
    case 'bookmark': return <svg {...props}><path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/></svg>;
    case 'challenge-star': return <svg {...props}><path d="M6 9H4a2 2 0 0 1-2-2V5h4"/><path d="M18 9h2a2 2 0 0 0 2-2V5h-4"/><path d="M12 17v4"/><path d="M8 21h8"/><path d="M6 5h12v6a6 6 0 0 1-6 6 6 6 0 0 1-6-6V5z"/></svg>;
    case 'challenge-flame': return <svg {...props}><path d="M8.5 14.5A2.5 2.5 0 0 0 11 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 1 1-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 0 0 2.5 2.5z"/></svg>;
    case 'challenge-heart': return <svg {...props}><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>;
    default: return <svg {...props}><circle cx="12" cy="12" r="9"/></svg>;
  }
};

const IconShare = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
    <polyline points="16 6 12 2 8 6"/>
    <line x1="12" y1="2" x2="12" y2="15"/>
  </svg>
);

function formatDate(iso) {
  if (!iso) return null;
  return new Date(iso).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export default function BadgesHome({ earnedBadges }) {
  const [expanded, setExpanded] = useState(false);
  const [selectedSlug, setSelectedSlug] = useState(null);
  const [badgeParaCompartilhar, setBadgeParaCompartilhar] = useState(null);

  const conquistadas = earnedBadges.filter(b => b.earned);
  if (!conquistadas.length) return null;

  const total = earnedBadges.length;
  const progressPct = Math.round((conquistadas.length / total) * 100);
  const selectedBadge = conquistadas.find(b => b.slug === selectedSlug);

  // Badge mais recente para o indicador "Novo"
  const maisRecente = conquistadas.reduce((latest, b) => {
    if (!b.earnedAt) return latest;
    if (!latest || new Date(b.earnedAt) > new Date(latest.earnedAt)) return b;
    return latest;
  }, null);

  return (
    <>
      <div className="jornada-card">
        {/* ── Header ── */}
        <div className="jornada-top">
          <div className="jornada-trophy-circle">
            <BadgeIcon slug="trophy" size={22} />
          </div>
          <div className="jornada-header-info">
            <div className="jornada-title-row">
              <span className="jornada-title">Sua jornada</span>
              <span style={{ fontSize: 16 }}>🏆</span>
            </div>
            <span className="jornada-subtitle">Cada passo importa. Celebre suas conquistas!</span>
          </div>
        </div>

        {/* ── Contagem + toggle + barra ── */}
        <div className="jornada-meta">
          <button
            className="jornada-toggle-btn"
            onClick={() => { setExpanded(e => !e); setSelectedSlug(null); }}
          >
            {expanded ? 'Recolher conquistas ↑' : 'Ver todas as minhas conquistas ↓'}
          </button>
          <div className="jornada-progress-wrap">
            <span className="jornada-count-text">{conquistadas.length} alcançadas / {total} conquistas</span>
            <div className="jornada-progress-track">
              <div className="jornada-progress-fill" style={{ width: `${progressPct}%` }} />
            </div>
          </div>
        </div>

        {/* ── Grid expandido ── */}
        {expanded && (
          <>
            <div className="jornada-grid">
              {conquistadas.map(badge => (
                <div
                  key={badge.slug}
                  className={`jornada-badge-item${selectedSlug === badge.slug ? ' selected' : ''}`}
                  onClick={() => setSelectedSlug(prev => prev === badge.slug ? null : badge.slug)}
                >
                  {maisRecente?.slug === badge.slug && (
                    <span className="jornada-badge-novo">Novo</span>
                  )}
                  <div className="jornada-badge-icon">
                    <BadgeIcon slug={badge.iconSlug} size={22} />
                  </div>
                  <span className="jornada-badge-name">{badge.name}</span>
                  {badge.earnedAt && (
                    <span className="jornada-badge-date">{formatDate(badge.earnedAt)}</span>
                  )}
                  <button
                    className="jornada-badge-share"
                    onClick={(e) => { e.stopPropagation(); setBadgeParaCompartilhar(badge); }}
                    aria-label={`Compartilhar ${badge.name}`}
                  >
                    <IconShare />
                  </button>
                </div>
              ))}
            </div>

            {/* ── Descrição ao clicar ── */}
            {selectedBadge && (
              <div className="jornada-badge-desc">
                <div className="jornada-badge-desc-icon">
                  <BadgeIcon slug={selectedBadge.iconSlug} size={16} />
                </div>
                <div>
                  <p className="jornada-badge-desc-name">{selectedBadge.name}</p>
                  <p className="jornada-badge-desc-text">{selectedBadge.description}</p>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {badgeParaCompartilhar && (
        <BadgeCelebrationModal
          badges={[badgeParaCompartilhar]}
          onDismiss={() => setBadgeParaCompartilhar(null)}
        />
      )}
    </>
  );
}
